import { render, staticRenderFns } from "./DrugOrderItemsRemovalEditDlg.vue?vue&type=template&id=80edc558&"
import script from "./DrugOrderItemsRemovalEditDlg.vue?vue&type=script&lang=js&"
export * from "./DrugOrderItemsRemovalEditDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports